import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'

import Navbar from '../components/navbar'
import BlogSidebars from '../components/blog-sidebar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import sanitizeHtml from 'sanitize-html'
import hero from '../assets/images/hero/h6.jpg'
import useCsrfToken from '../hooks/useCsrfToken'
import { Helmet } from 'react-helmet-async'

export default function BlogDetail() {
    const { csrfToken } = useCsrfToken();
    let [activeImage, setImage] = useState('');
    let params = useParams();
    const [listing, setListing] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;

    const stripAllTagsFromHtml = (html) => {
        return sanitizeHtml(html, {
            allowedTags: []
        });
    };


    useEffect(() => {
        // if (csrfToken === null) return;
        let slug = params.slug
        const transformData = (data) => {
            const formattedDate = new Date(data.created_at).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            const stripTagsFromHtml = (html) => {
                const allowedTags = ['b', 'u', 'i', 'p', 'br', 'span', 'strong', 'em', 'a'];
                return sanitizeHtml(html, {
                    allowedTags: allowedTags
                });
            };

            return {
                id: data.id,
                image: `${API_URL}${data.primary_image}`,
                tag: 'Blog',
                name: data.title,
                slug: data.slug,
                intro: data.intro !== '' ? stripTagsFromHtml(data.intro) : '',
                desc: data.description !== '' ? stripTagsFromHtml(data.description) : '',
                tags: data.tags,
                gallery: data.gallery?.gallerythumbs,
                gallerylarge: data.gallery?.galleryimages,
                brochure_url: data.brochure_url,
                cta_url: data.cta_url,
                phone_1: data.phone_1,
                title: data.title,
                listing_type: data.listing_type,
                date: formattedDate,
                embed: data.embed
            };
        };
        fetch(`${API_URL}/api/listing/${slug}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'X-CSRF-TOKEN': csrfToken,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.json())
            .then(data => {
                setListing(transformData(data))
                if (activeImage === '') {
                    setImage(API_URL + data.gallery?.galleryimages[0].url_large);
                }

            })
            .catch(error => console.error('Error fetching data:', error));
    }, [API_URL, params, activeImage, csrfToken]);

    const basedomain = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <Helmet>
                <title>{`${listing.name} | Blog | Hospital Aranda de La Parra`}</title>
                <meta name="description" content={`${stripAllTagsFromHtml(listing.intro)}`} />
                <meta property="og:title" content={`${listing.name} | Blog | Hospital Aranda de La Parra`} />
                <meta property="og:description" content={`${stripAllTagsFromHtml(listing.intro)}`} />
                <meta property="og:image" content={`${listing?.image ? listing?.image : hero}`} />
                <meta property="og:url" content={`${basedomain}/blog-leer/${listing.slug}`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`${listing.name} | Blog | Hospital Aranda de La Parra`} />
                <meta name="twitter:description" content={`${stripAllTagsFromHtml(listing.intro)}`} />
                <meta name="twitter:image" content={`${listing?.image ? listing?.image : hero}`} />
                <meta itemprop="name" content={`${listing.name} | Blog | Hospital Aranda de La Parra`} />
                <meta itemprop="description" content={`${stripAllTagsFromHtml(listing.intro)}`} />
                <meta itemprop="image" content={`${listing?.image ? listing?.image : hero}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <span className="badge bg-primary">{listing?.tag ? listing?.tag : 'HAP'}</span>
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark mt-4">{listing?.title ? listing?.title : 'Si título'}</h5>

                                <ul className="list-inline text-center mb-0">
                                    <li className="list-inline-item mx-4 mt-4">
                                        <span className="text-white-50 d-block">Autor</span>
                                        <Link to="#" className="text-white title-dark">HAP</Link>
                                    </li>

                                    <li className="list-inline-item mx-4 mt-4">
                                        <span className="text-white-50 d-block">Fecha</span>
                                        <span className="text-white title-dark">{listing?.date ? listing?.date : '19th June 2024'}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page"><Link to="/blog">Blog</Link></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            <div className="card border-0 shadow rounded overflow-hidden">
                                <img src={listing?.image ? listing?.image : hero} className="img-fluid" alt="" />

                                <div className="card-body">
                                    {listing.embed && listing.embed.includes('<') && (
                                        <div className="text-center mb-2 p-3 pt-1 position-relative" dangerouslySetInnerHTML={{ __html: listing.embed }} />
                                    )}
                                    {(!listing.embed || !listing.embed.includes('<')) && (
                                        <>
                                            <img src={activeImage ? activeImage : listing.image} className="img-fluid galMainImage w-100" alt="" />
                                            <div className="row mt-4">
                                                {listing.gallery && listing.gallery.map((item, index) => (
                                                    <div key={index} className="col-4 col-md-2">
                                                        <Link onClick={() => setImage(API_URL + listing.gallerylarge[index].url_large)}>
                                                            <img src={API_URL + item.url_thumbnail} alt="Galería" className='img-fluid' />
                                                        </Link>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                    <blockquote className="text-center mx-auto blockquote">
                                        <i className="mdi mdi-format-quote-open mdi-48px text-muted opacity-2 d-block"></i>
                                        <div dangerouslySetInnerHTML={{ __html: listing.intro }} />
                                    </blockquote>

                                    <div className="text-muted" dangerouslySetInnerHTML={{ __html: listing.desc }} />
                                    {listing.tags && listing.tags.map((item, index) => (
                                        <Link key={index} to="#" className="badge badge-link me-1" style={{ backgroundColor: item.color }}>
                                            {item.title}
                                        </Link>
                                    ))}
                                    {listing.embed && listing.embed.includes('<') && (
                                        <div className="mt-4">
                                            <img src={activeImage ? activeImage : listing.image} className="img-fluid galMainImage w-100" alt="" />
                                            <div className="row mt-4">
                                                {listing.gallery && listing.gallery.map((item, index) => (
                                                    <div key={index} className="col-4 col-md-2">
                                                        <Link onClick={() => setImage(API_URL + listing.gallerylarge[index].url_large)}>
                                                            <img src={API_URL + item.url_thumbnail} alt="Galería" className='img-fluid' />
                                                        </Link>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-5 col-12 mt-4 pt-2 mt-md-0 pt-md-0">
                            <BlogSidebars />
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <ScrollToTop />
        </>
    )
}
